<template>
  <div id="contact-container">
    <div
      class="row justify-content-between align-items-center p-0"
      id="contact-header"
    >
      <h2 id="title" class="col-6">
        {{ $t("coworking-info.contact-form.title") }}
      </h2>
      <p v-if="isEdit" id="info" class="col mb-0">
        {{ $t("utils.form.required-label") }}
      </p>
    </div>
    <div id="contact-info" class="mt-4" v-if="!isEdit">
      <div class="d-inline">
        <div class="row mt-4">
          <div class="col">
            <h2>{{ $t("coworking-info.contact-form.email-placeholder") }}</h2>
            <p>{{ info.email }}</p>
          </div>
        </div>
      </div>
    </div>

    <div id="contact-form" class="mt-4" v-else>
      <b-form-group class="d-inline">
        <div class="row">
          <b-form-input
            v-model="info.email"
            required
            :placeholder="$t('coworking-info.contact-form.email-placeholder')"
            class="form col"
          />
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info", "isEdit"]
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";
@import "src/assets/scss/forms";

::placeholder {
  color: #777777 !important;
}

#contact-header {
  width: 100%;

  #title {
    margin-top: 0.5%;
    font-family: $worksans;
    font-style: normal;
    font-weight: 600;
    font-size: 24.22px;
    line-height: 38px;
    color: #161616;
  }

  #info {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #ff3333;
    text-align: end;
    margin-right: 2rem;
  }
}

#contact-info {
  width: 750px;

  h2 {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #767676;
  }

  p {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }
}

#contact-form {
  width: 750px;

  .row {
    --bs-gutter-x: 0;
  }

  ::placeholder {
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/info/components/Contact.vue